import { hitEvent } from './hitEvents';
import { isAlloyReady } from './alloy';

/**
 * Track an analytics event
 * 
 * @param {string} eventId - The Adobe Analytics event ID (e.g., 'event4', 'event10')
 * @param {Object} props - The props object built by caller using variableMap (values as strings)
 * @returns {Promise<void>}
 * 
 * @example
 */
export async function trackEvent(eventId, props = {}) {
  if (!isAlloyReady()) {
    console.warn('Analytics not ready. Event not tracked:', eventId);
    return;
  }

  try {
    await hitEvent(eventId, props);

    if (process.env.NODE_ENV === 'development') {
      console.log('Tracked event:', {
        eventId,
        props,
      });
    }
  } catch (error) {
    console.error('Error tracking event:', eventId, error);
  }
}
